module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "login-container"
    }
  }, [_c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginRules,
      "label-width": "0px",
      "id": "login-form"
    }
  }, [_c('h3', [_vm._v("Login")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "email"
    },
    model: {
      value: (_vm.loginForm.email),
      callback: function($$v) {
        _vm.loginForm.email = $$v
      },
      expression: "loginForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleLogin($event)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.loginForm.password = $$v
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "id": "login-btn"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleLogin($event)
      }
    }
  }, [_vm._v("Login")])], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', [_c('li', [_vm._v("Emails: admin@test.com, editor@test.com")]), _vm._v(" "), _c('li', [_vm._v("admin@test.com could access all pages")]), _vm._v(" "), _c('li', [_vm._v("editor@test.com can see homepage only")]), _vm._v(" "), _c('li', [_vm._v("Password is anything you like but at least 6 digits")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa0c302","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/index.vue
// module id = 755
// module chunks = 2